<template>
	<CreationWizardStepWrapper>
		<template #header>
			<GoToExtToInstallAddOnHeader v-bind="$props" v-on="$listeners" />
		</template>
		<div class="display-flex flex-wrap">
			<div class="flex-col-12">
				<ol>
					<li>
						<h3 class="reg">
							Go to the app you want to add a feature to.
							<a href="https://docs.ply.io/article/19xtrvr7rz-compatibility" target="_blank">Here's a list of apps we support</a>
						</h3>
					</li>
					<li><h3 class="reg">Click the Ply extension</h3></li>
					<li><h3 class="reg">Click "Create new module"</h3></li>
				</ol>
			</div>
			<div class="flex-col-12">
				<v-img :src="UseTheExtensionImage" class="mt-6" width="500" />
			</div>
		</div>
	</CreationWizardStepWrapper>
</template>

<script>
import props from './GoToExtToInstallAddOn.props';
import GoToExtToInstallAddOnHeader from './GoToExtToInstallAddOnHeader.vue';
import WizardStepMixin from '../WizardStepMixin';
import UseTheExtensionImage from '@/assets/png/icon-use-the-extension.png';
export default {
	name: 'GoToExtToInstallAddOn',
	props,
	mixins: [WizardStepMixin],
	components: { GoToExtToInstallAddOnHeader },
	data() {
		return { UseTheExtensionImage };
	},
};
</script>

<style lang="scss" scoped>
a {
	color: var(--text-link-color);
}
</style>
